import Vue from 'vue';
import Vuex, {StoreOptions } from 'vuex';
import { RootState } from './types';
import { login, state } from './login/index';
import { functions } from './functions/index';
import { threadRepository } from './threadRepository/index';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
    state: {
        version: '1.0.0',
        login: state,
    },
    modules: {
        login,
        functions,
        threadRepository,
    },
};

export default new Vuex.Store<RootState>(store);
